import cn from 'classnames';
import { ReactNode } from 'react';
import { MdClose } from 'react-icons/md';
import { IconButton } from '../IconButton';
import { Appearance, Design, Size } from '../designConstants';

interface SidePanelProps {
  title?: ReactNode;
  rightActions?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  show: boolean;
  onHide: () => void;
}

export const SidePanel = ({ title, rightActions, body, footer, show, onHide }: SidePanelProps) => (
  <div className={cn('side-panel-container', { open: show, closed: !show })}>
    <div className='side-panel'>
      <div className='side-panel-header'>
        <div className='side-panel-title'>{title}</div>
        <div className='side-panel-right-actions'>
          {rightActions}
          <IconButton
            appearance={Appearance.EMPTY}
            size={Size.SM}
            design={Design.NEUTRAL}
            onClick={onHide}
          >
            <MdClose />
          </IconButton>
        </div>
      </div>
      <div className='side-panel-body'>{body}</div>
      {footer && <div className='side-panel-footer'>{footer}</div>}
    </div>
  </div>
);
